import { MembersMgmt } from "~/components/Members";

export type MembersProps = {};

export function Members({}: MembersProps) {
  return (
    // Members Mgmt is being reused in both the space and org level
    <MembersMgmt />
  );
}
